<!--
 * @Author: Scarlett Xiao
 * @Date: 2021-12-20 14:36:20
 * @LastEditors: dong
 * @LastEditTime: 2025-11-03 17:41:11
-->

<template>
  <div>
    <!-- <div v-if="/mobile/i.test($route.path)">
      <Mobile></Mobile>
    </div> -->
    <div
      id="app"
      :class="'big-screen ' + pageClass"
      :data="pageClass"
    >
      <div class="container-wrap">
        <!-- 头部 -->
        <h1
          class="container-title"
          title="优鱼（广州）技术有限公司"
        >
          <span
            class="obj-title"
            style="width: 276px; height: 38px"
          ></span>
          <div class="login-txt" @click="openUyuDemo">
            {{ $t("settings.platform") }}
            <!-- <div class="platform-wrap">
              <div class="platform-container">
                <div
                  class="platform-container-line"
                  v-for="(item, idx) in uyuPlatform"
                  v-if="!(idx % 2)"
                >
                  <span
                    @click="clickLink(item)"
                    :title="item.txt"
                  >{{
                    item.txt
                  }}</span>
                  <span
                    v-if="uyuPlatform[idx + 1]"
                    @click="clickLink(uyuPlatform[idx + 1])"
                    :title="uyuPlatform[idx + 1].txt"
                  >{{ uyuPlatform[idx + 1].txt }}</span>
                </div>
              </div>
            </div> -->
          </div>
          <div
            class="changebtn"
            id="pagebtn"
          >
            <!-- <label
            id="slider"
            ref="slider"
          ></label> -->
            <a
              id="listbtn"
              :class="{ langAct: lang === 'zh' }"
              @click="translate('zh')"
            >中文</a>
            <a
              id="detailbtn"
              :class="{ langAct: lang === 'en' }"
              @click="translate('en')"
            >English</a>
          </div>
        </h1>
        <!-- 内容 -->
        <div class="container-content">
          <router-view />
        </div>
        <!-- 底部导航条 -->
        <div class="container-tab">
          <containerTab />
        </div>
      </div>
      <!-- 百度地图位置 -->
      <!-- <baiduMapComponent /> -->
      <!-- 首页背景图片位置 -->
      <HomeBgImage />

    </div>
  </div>
</template>

<script>
import containerTab from "../../components/container-tab.vue";
import baiduMapComponent from "../../components/baidu-map/baidu-map-component.vue";
import { getLanguage } from "../../lang/index";
import Mobile from "../mobile/Mobile.vue";
import HomeBgImage from '../../components/home-bg-image.vue';
export default {
  name: "app",
  components: {
    containerTab,
    // baiduMapComponent,
    Mobile,
    HomeBgImage
  },
  provide() {
    return {
      app: this,
    };
  },
  data() {
    return {
      screenfull: null,
      map: null, // 百度地图引用
      uyuPlatform: [
        // 优鱼平台
        {
          txt: "智慧渔业管理平台",
          link: "https://ufish-admin.uyu1027.com",
        },
        // {
        //   txt: "U鱼商城管理平台",
        //   link: "https://shop-admin.uyu1027.com",
        // },
        // {
        //   txt: "IoT一张图",
        //   link: "http://iot-visual.uyu1027.com",
        // },
        {
          txt: "IoT物联网平台",
          link: "https://iot.uyu1027.com/desktop/analysis",
        },
      ],
    };
  },
  methods: {
    // 跳转养殖平台
    clickLink(item) {
      window.open(item.link, "_block");
    },
    // 语言切换
    translate(lang) {
      // const slider = document.getElementById("slider");
      // const listbtn = document.getElementById("listbtn");
      // const detailbtn = document.getElementById("detailbtn");
      if (lang == "zh") {
        // slider.setAttribute("data", "left");
        // slider.innerText = listbtn.innerText;
        this.lang = "zh";
      } else {
        // slider.setAttribute("data", "right");
        // slider.innerText = detailbtn.innerText;
        this.lang = "en";
      }
    },
    fontHandle(num, unit) {
      /**
       * @desc    计算当前 rem 系数，可用于字号或其他需要等比适应的操作
       * @param   {Number}    num
       *
       * @return  {Number}
       */
      let docEl = document.documentElement;
      let clientWidth = docEl.clientWidth;
      if (!clientWidth) return;

      // rem与px相转换的比例系数
      let remUnit = 12;
      // UI设计稿宽度
      let designWidth = 1920;

      let standardFontSize = (clientWidth / (designWidth / remUnit)) * 1;
      let endNum = standardFontSize * (num / 100).toFixed(2) * 1;
      return unit ? endNum + unit : endNum;
    },
    openUyuDemo() {
      window.open("http://uyu-demo.uyu1027.com/", "_blank");
    },
  },
  mounted() {},
  created() {
    document.title = this.$t("settings.title");
    // 获取缓存的语言
    const lang = getLanguage();
    setTimeout(() => {
      this.translate(lang);
      this.lang = lang;
    }, 0);
    // 获取用户IP并存入数据库
    // const mapKey = "F4KBZ-SA2K6-KU3SZ-M35WS-2IBL5-ATFFZ";
    // const url = "https://apis.map.qq.com/ws/location/v1/ip?";
    // this.$jsonp(url, {
    //   key: mapKey,
    //   output: "jsonp",
    // }).then((res) => {
    //   console.log(res.result,'PC端-获取访问用户IP地址');
    // });
  },
  computed: {
    pageClass: function () {
      return this.$route.name || "home";
    },
    lang: {
      get() {
        return this.$store.state.app.language;
      },
      set(lang) {
        this.$i18n.locale = lang;
        this.$store.dispatch("app/setLanguage", lang);
      },
    },
  },
  watch: {
    lang() {
      document.title = this.$t("settings.title");
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif, AlibabaPuHuiTi-Medium;
  -webkit-font-smoothing: antialiased;
}

// 初始样式
@import "./init.less";
// 修改elementUI主题样式
@import "../../assets/less/theme-style.less";
</style>
<style lang="less" scoped>
// 当前页面样式
@import "./app.less";
@import "../../assets/less/module-style.less";
</style>
